function ListGroupType2({ name = "radio1", label = "Fill Label", option1 = "Option 1", option2 = "Option 2", onChange = () => {}, isLoading = false, defaultValue = true }) {
  const handleChange = (val) => {
    onChange(val);
  };
  return (
    <>
      <div className="list-group list-group-flush">
        <div className="list-group-item d-flex align-items-center">
          <div className="flex-1 text-break">
            {isLoading ? (
              <div className="spinner-border spinner-border-sm text-theme"></div>
            ) : (
              <div className="col-xl-6">
                <div className="small text-theme mb-1">
                  <b>{label}</b>
                </div>
                <div className="form-group mb-1">
                  <div className="form-check">
                    <input onChange={(e) => handleChange(e.target.checked)} className="form-check-input" type="radio" defaultChecked={defaultValue} name={name} id="defaultRadio1" />
                    <label className="form-check-label" htmlFor="defaultRadio1">
                      {option1}
                    </label>
                  </div>
                  <div className="form-check">
                    <input onChange={(e) => handleChange(!e.target.checked)} className="form-check-input" type="radio" defaultChecked={!defaultValue} name={name} id="defaultRadio2" />
                    <label className="form-check-label" htmlFor="defaultRadio2">
                      {option2}
                    </label>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
export default ListGroupType2;
